

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import UploadBlock from "./components/UploadBlock.vue";
import orgImportTable from "./components/orgImportTable.vue";

const userManager = namespace("userManager");
const root = namespace("root");
const scan = namespace("scan");
@Component({
  components: {
    orgImportTable,
    UploadBlock
  }
})
export default class add extends Vue {
  dialogVisible: boolean = false;
  loading: boolean = false;
  @Prop() editData: any = null;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  @root.Action getSystemValue;
  @root.State mainRouter;
  @scan.Action importCustomerLevelStoreFile;
  templateUrl: string = "";
  notice: any = "";
  inputNotice: any = "";
  form: any = {
    id: null,
    levelCode: null,
    levelName: "",
    fileName: null,
    fileUrl: null,
    importStoreList: []
  };
  formAcTagSearch: any = [];
  rules: any = {
    levelName: [
      {
        required: true,
        message: "名称不能为空"
      }
    ]
  };
  @scan.Action editCustomerLevel;
  created() {
    this.getTemplateUrl();
    this.editData && this.setData();
  }
  replaceInput(value) {
    // let val = value.replace(/[^A-Za-z\u4E00-\u9FA5$]/g, "");
    let val = value;
    if (val && val.length > 6) {
      if (!this.inputNotice || this.inputNotice.closed) {
        this.inputNotice = this.$message.error("级别名称最多可输入6位");
      }
      val = val.slice(0, 6);
    }
    this.form.levelName = val;
  }
  @Watch("dialogVisible")
  onEditDataChange(val) {
    this.$nextTick(() => {
      (this as any).$refs.form.resetFields();
      this.setData();
    });
  }
  @Watch("form.importStoreList") handleTag(val) {
    if (Array.isArray(val)) {
      this.formAcTagSearch = val;
    }
  }
  setData() {
    if (!this.editData) {
      this.form = {
        id: null,
        levelCode: null,
        levelName: "",
        fileName: null,
        fileUrl: null,
        importStoreList: []
      };
    } else {
      let {
        id = null,
        levelCode = null,
        levelName = "",
        fileName = null,
        fileUrl = null,
        baseStoreList = []
      } = this.editData;
      this.form = {
        id,
        levelCode,
        levelName,
        fileName,
        fileUrl,
        importStoreList: baseStoreList
      };
    }
  }

  async onUploaderChange(File: any = {}) {
    const { name = "file" } = File.file;
    const { filePath = "" } = File;
    const { val = [] } = File;
    let list = val.map(el => (el.门店编码 ? String(el.门店编码) : ""));
    list = list.filter(el => el);
    // if (!list || !list.length) {
    //   this.$message.error("上传文件没有有效数据，请重新上传");
    //   return;
    // }
    list = list.map(v => ({ storeCode: v }));
    // this.form.importStoreList = list;
    this.form.fileName = name;
    this.form.fileUrl = filePath;
    this.$message.success("上传成功");
  }

  async getTemplateUrl() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "TAG_STORE_URL"
    });
    this.templateUrl = valueValue;
  }

  fAcTags(orgCodes) {
    // const vals = orgCodes.map(el => ({
    //   门店编码: el.门店编码 ? String(el.门店编码) : String(el)
    // }));
    return orgCodes;
  }
  routeParams: any = '5';
  handleViewImport() {
    this.notice && this.notice.close();

    let menuMap: any = JSON.parse(localStorage.getItem("menuListMap") || "{}");
    let ygjExportPath: any = "/app/k-one-frontend/import";
    let appCode = (window as any).__GTECH_VARIABLES_APP_CODE__;

    if (menuMap[ygjExportPath]) {
      // "K-ONE", "WIN-TOGETHER-TBR"
      if (appCode === "WIN-TOGETHER-TBR" && this.mainRouter) {
        let routeUrl = this.mainRouter.resolve({
          path: ygjExportPath,
          query: { importParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
      if (["WIN-TOGETHER", "WIN-TOGETHER-CN"].includes(appCode)) {
        let routeUrl = this.$router.resolve({
          path: ygjExportPath,
          query: { importParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
    }

    let routeUrl = this.$router.resolve({
      path: "/import",
      query: { importParams: String(this.routeParams || "") }
    });
    window.open(routeUrl.href, "_blank");
  }
  importMarket() {
    const h = this.$createElement;
    this.notice = this.$message({
      type: "success",
      duration: 5000,
      showClose: true,
      customClass: "gt-export-dialog-message-wrap",
      message: h("div", { class: "gt-export-dialog-product-success" }, [
        h("p", null, "导入请求已经成功提交"),
        h(
          "p",
          {
            class: "gt-export-dialog-product-view",
            on: {
              click: this.handleViewImport
            }
          },
          "查看导入状态"
        )
      ])
    });
  }
  async handleSubmit() {
    if (!this.form.importStoreList.length && !this.form.fileUrl) {
      this.$message.error("请上传文件");
      return;
    }
    const $form: any = this.$refs["form"];
    $form.validate(async valid => {
      if (valid) {
        let {
          id = null,
          levelCode = null,
          levelName = "",
          fileName = null,
          fileUrl = null
        } = this.form;
        this.loading = true;
        try {
          await this.editCustomerLevel({
            customerLevelInput: {
              id,
              levelCode,
              levelName,
              fileName,
              fileUrl
            }
          })
            .then(_ => {
              this.$emit("refresh");
              this.dialogVisible = false;
              // if (this.isEdit) {
              //   this.$message({ type: "success", message: "编辑成功" });
              // } else {
              //   this.$message({ type: "success", message: "新增成功" });
              // }
              this.importMarket();
              (this as any).$refs.form.resetFields();
            })
            .finally(_ => {
              this.loading = false;
            });
        } catch (error) {
          console.log(error);
        }
      }
    });
  }
}
